export default "__VITE_ASSET__DJGEosZh__"